import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ypp_admin_token";

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [checking, setChecking] = useState(!!localStorage.getItem(TOKEN_KEY));

  // Validate stored token on mount so a stale/wrong token kicks user back to login
  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await axios.get(`${API}/admin/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setChecking(false);
      } catch {
        if (!cancelled) {
          localStorage.removeItem(TOKEN_KEY);
          setToken("");
          setChecking(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  // Set page title for the admin route
  useEffect(() => {
    const prev = document.title;
    document.title = "Admin · Your Phone Plug Leads";
    return () => { document.title = prev; };
  }, []);

  const handleLogin = useCallback((newToken) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50" data-testid="admin-loading">
        <div className="text-sm text-slate-500">Loading admin…</div>
      </div>
    );
  }

  if (!token) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return <AdminDashboard token={token} onLogout={handleLogout} />;
}
